var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.CNF('copyright.visiable', true))?_c('div',[_vm._v(" "+_vm._s(_vm.CNF('copyright.text', ''))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }